import React, {ReactNode} from "react";
import {SvgIcon} from "@mui/material";
import {AbstractIconProps} from "./AbstractIcon.types";


abstract class AbstractIcon extends React.Component<AbstractIconProps>   {


    public render(): ReactNode   {
        return (
            <SvgIcon key={"icon-" + this.props.key} {...this.props}>
                {this.renderDraw(this.props)}
            </SvgIcon>
        );
    }


    public abstract renderDraw(props: AbstractIconProps): ReactNode;

}


export default AbstractIcon;
